import React from 'react';
import cn from 'classnames';

import { Datepicker } from '@components/common';
import StatisticList from '@components/common/StatisticList';

import { IExportFileDTO } from '@interfaces/platform/dto/platformDashboardDTO';

import { IStatisticSummaryList } from '../utils';

import DashboardPOWhiteCard from '../DashboardPOWhiteCard';

import styles from './DashboardStatisticSummary.module.scss';

interface IDashboardStatisticSummary {
	fromDate: Date | null | undefined;
	toDate: Date | null | undefined;
	setFromDate: (date: number | null) => void;
	setToDate: (date: number | null) => void;
	allAssetsData: IStatisticSummaryList;
	handleSummaryExport?: ({ fileType }: IExportFileDTO) => void;
	isLoadingDashboardAssetsSummary: boolean;
	isLoadingDashboardRentGeneralSummary: boolean;
	openPerOrganizationTable?: () => void;
	requestsData: IStatisticSummaryList;
	statisticClassName: string;
}

const DashboardStatisticSummary = ({
	fromDate,
	handleSummaryExport,
	isLoadingDashboardAssetsSummary,
	isLoadingDashboardRentGeneralSummary,
	openPerOrganizationTable,
	requestsData,
	setFromDate,
	setToDate,
	toDate,
	allAssetsData,
	statisticClassName,
}: IDashboardStatisticSummary) => {
	const statisticSummaryClasses = cn(styles.statisticSummary, statisticClassName);

	return (
		<>
			<div className={statisticSummaryClasses}>
				<DashboardPOWhiteCard title='Completed requests'>
					<div className={styles.datepickerWrapper}>
						<Datepicker
							key='fromDate'
							disableInput
							handleChange={setFromDate}
							isClearable
							isFullWidth
							isMobileDevice={false}
							selected={fromDate}
						/>
						<span className={styles.datepickerSeparator}>-</span>
						<Datepicker
							key='toDate'
							disableInput
							handleChange={setToDate}
							isClearable
							isFullWidth
							isMobileDevice={false}
							selected={toDate}
						/>
					</div>
					<StatisticList
						isLoading={isLoadingDashboardRentGeneralSummary}
						items={requestsData.list}
						title={requestsData.title}
						total={requestsData.total}
					/>
				</DashboardPOWhiteCard>
				<DashboardPOWhiteCard
					handleExport={handleSummaryExport}
					isWithExport={!!handleSummaryExport}
					title='Summary'
				>
					<StatisticList
						isLoading={isLoadingDashboardAssetsSummary}
						isWithViewIcon={!!openPerOrganizationTable}
						items={allAssetsData.list}
						onClick={openPerOrganizationTable}
						title={allAssetsData.title}
						tooltipLabel='Details'
						total={allAssetsData.total}
					/>
				</DashboardPOWhiteCard>
			</div>
		</>
	);
};

export default DashboardStatisticSummary;
